'use client';

import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import type { CheckboxRootProps } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormBaseInputProps } from '../../../types';
import { FormField } from '../../wrapper';

export type CheckboxProps<T> = FormBaseInputProps<T> & Omit<CheckboxRootProps, 'name'>;

export const Checkbox = <T extends Record<string, unknown>>({
	children,
	helperText,
	label,
	name,
	optionalText,
	required,
	...checkboxRootProps
}: CheckboxProps<T>) => {
	const { control } = useFormContext();

	return (
		<FormField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={required}
		>
			<Controller
				control={control}
				name={name}
				render={({ field }) => (
					<ChakraCheckbox.Root
						{...checkboxRootProps}
						checked={field.value}
						onCheckedChange={({ checked }) => field.onChange(checked)}
					>
						<ChakraCheckbox.HiddenInput />
						<ChakraCheckbox.Control />
						<ChakraCheckbox.Label>
							{children}
						</ChakraCheckbox.Label>
					</ChakraCheckbox.Root>
				)}
			/>
		</FormField>
	);
};
